<template>
    <div>
        <div class="flex bottom8">

            <el-select style="width: 145px"  class="marr4" v-model="i_gsid" size="mini" clearable :placeholder="$t('form_please_select_a_company')" >
                <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                </el-option>
            </el-select>
            <el-select style="width: 145px"  class="marr4" v-model="i_khid" size="mini" clearable remote :remote-method="remoteMethodkh" filterable placeholder="请选择客户">
                <el-option v-for="item in khList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                </el-option>
            </el-select>
            <el-select  style="width: 100px"  class="marr4" v-model="i_bzid" size="mini"  placeholder="请选择币种">
                <el-option
                        v-for="item in bzList"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-button class="mrl20" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
<!--            <el-button class="mrl20" icon="el-icon-refresh" circle  @click="clearSearchData" size="mini"></el-button>-->
        </div>
        <el-table
                class="mrt10"
                ref="table"
                size="mini"
                :height="tableHeight"
                border
                :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%;margin-right: 9px;margin-left: 9px">
            <el-table-column  :label="$t('form_serial_number')" align="center" type="index" width="50px"></el-table-column>
            <el-table-column align="center" label="客户名称" prop="vc_khname"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="公司名称" prop="vc_gsname"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="金额" width="100px" prop="f_remainAmount"  show-overflow-tooltip>
                <template  slot-scope="scope">
                    <div style="text-align: right"> {{scope.row.f_remainAmount}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="币种" width="60px" prop="vc_bzname"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="汇率" width="75px" prop="f_rate"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="类型" width="75px" prop="vc_type"    show-overflow-tooltip></el-table-column>
<!--            <el-table-column align="center" label="录入人" width="80px" prop="vc_lruname"   show-overflow-tooltip></el-table-column>-->
<!--            <el-table-column align="center" label="登记日期" prop="dt_applytime" width="90px"  show-overflow-tooltip></el-table-column>-->
<!--            <el-table-column align="center" label="备注" prop="vc_note"    show-overflow-tooltip></el-table-column>-->

            <el-table-column align="center" label="操作" prop="f_txlv1"  show-overflow-tooltip width="60px">
                <template slot-scope="scope">
                    <el-button   type="text" @click="detail(scope.row)">分解</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        @size-change="sizeChange"
                        :page-sizes="[20,50,100]"
                        layout="total,sizes,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog
                    class="cldialog"
                    style="display: flex;justify-content: center;align-items: center;"
                    width="830px"
                    top="30"
                    height="300"
                    title="分解"
                    :visible.sync="detailDialog"
                    v-if="detailDialog"
                    :close-on-click-modal="false" @close="detailClose">
                <detail-page :data="detailData" @close="detailClose"></detail-page>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import DetailPage from "./DetailPage"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "index",
        components: {
            DetailPage,
        },
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                detailData:{},
                detailDialog:false,
                detailTitle:'新增',
                gsList:[],
                i_gsid:0,
                bzList:[],
                i_bzid:1,
                khList:[],
                i_khid:null,
                searchkh:'',
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.getbzlist();
            // this.getDictForAmountDivide();
            this.getCompanyList();
            this.getAmountForDivide();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

            },
            detail(item){
                this.detailData=JSON.parse(JSON.stringify(item));
                // this.detailData.i_bzid=this.i_bzid;
                // this.detailData.vc_bzname=this.bzList.find(bz=>bz.i_id==this.i_bzid).vc_name;
                // this.detailData.f_rate=this.bzList.find(bz=>bz.i_id==this.i_bzid).f_rate;
                this.detailDialog=true;
            },
            detailClose(type='back'){
                if(type=='save'){
                    this.currentPage=1;
                    this.getAmountForDivide()
                }
                this.detailDialog=false;

            },
            gosearch(){
                this.currentPage=1;
                this.getAmountForDivide()
            },
            clearSearchData(){
                this.i_gsid=0;
                this.i_khid=0;
                this.i_sktype=0;
                this.vc_bank_account='';
                this.vc_search='';
                this.i_isuse=-1;
                this.currentPage=1;
                this.getAmountForDivide()
            },
            remoteMethodkh(val){
                this.searchkh=val;
                this.getDictForAmountDivide()
            },
            async getDictForAmountDivide(){
                let param={
                    vc_khname: this.searchkh,
                };
                let res=await API.getDictForAmountDivide(param);
                if ( res.code == 1 ){
                    this.khList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){

                let param={
                    i_type:'0,2',
                    i_mid:this.mid,
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                    this.gsList.unshift({i_id:0,vc_name:'全部公司'})
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getAmountForDivide();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getAmountForDivide();
            },
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getAmountForDivide(){

                let param={
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    i_gsid:this.i_gsid==""?0:this.i_gsid,
                    i_bzid:this.i_bzid,
                    i_khid:this.i_khid==""?null:this.i_khid,
                };
                let res=await API.getAmountForDivide(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.amountList;
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        align-items: center;
        flex-wrap:wrap ;

    }
    .bottom8{
        margin: 8px;
    }
</style>